import { getSpotStatus, SpotStatus, type ISpot } from '@nova/core';

/**
 * FE adapter for the one spot-status variant the UI still collapses:
 *
 * - LOCKED -> CLOSED. A LOCKED spot is the origin of an active move task; the
 *   non-overlay consumers (useYardSpotSelect, useYard, the spot presenter)
 *   render it as closed. The "assigned" appearance of such a spot comes from
 *   useYardSpotStatus reading the raw LOCKED status directly, not from this
 *   legacy view. Mapping to CLOSED keeps non-overlay consumers functionally
 *   equivalent.
 *
 * RESERVED_MANUAL / RESERVED_AUTOMATED now pass through untouched — the UI
 * handles them directly (icons, colors, i18n, status strategies).
 *
 * Delete once the UI also handles LOCKED directly.
 */
const NEW_TO_LEGACY: Partial<Record<SpotStatus, SpotStatus>> = {
  [SpotStatus.LOCKED]: SpotStatus.CLOSED
};

export function toLegacySpotStatus(status: SpotStatus): SpotStatus {
  return NEW_TO_LEGACY[status] ?? status;
}

export function getLegacySpotStatus(spot: ISpot): SpotStatus {
  return toLegacySpotStatus(getSpotStatus(spot));
}
